import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=650c57bd&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=650c57bd&prod&lang=less&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=650c57bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650c57bd",
  null
  
)

export default component.exports